export const cookiesSectionData = {
  bodyText:
    'Joy uses cookies to offer you a better user experience. By clicking “Accept All”, you consent to our website\'s use of cookies in accordance with our <a class="privacy-link" href="https://privacy.withjoy.com/" target="blank">Privacy Policy</a>.',
  bodyTextDeclined:
    'We have disabled all cookies per your request. This might cause the site to not work fully. Would you like to enable them?',
  acceptAll: 'Accept All',
  decline: 'Decline',
} as const;
